import React from 'react';
import ElementBase from '../base';

function humanize(str) {
  let i;
  const frags = str.split('_');
  for (i = 0; i < frags.length; i += 1) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }

  return frags.join(' ');
}

function InvalidElement(props) {
  const { type } = props;

  return (
    <div className="EditorElement-content">
      <div className="EditorElement-body">
        <div className="EditorElement-fileHandler">
          <div className="EditorElement-fileHandler-content">
            <div className="EditorElement-fileHandler-content-inner">
              <div className="EditorElement-fileHandler-content-inner-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-8 fs-0"
                >
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <div
                style={{
                  marginTop: '2em',
                  marginBottom: '2em',
                }}
              >
                <p>Element type: {humanize(type)}</p>
              </div>
              <div className="EditorElement-fileHandler-content-inner-text">
                <p
                  style={{
                    marginTop: '1.5em',
                    marginBottom: '1.5em',
                  }}
                >
                  This element is missing content and cannot be rendered.
                </p>
                <p
                  style={{
                    marginTop: '1.5em',
                    marginBottom: '1.5em',
                  }}
                >
                  Publishing the lesson with this element will result in errors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ElementBase(InvalidElement);
